import styled, { css, keyframes } from 'styled-components';
import { OLAF, MARIGOLD, OBSIDIAN } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import withTransientStyleProps from '../utils/TransientStylePropsDecorator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const pulseKeyframe = keyframes(["0%{color:", "}100%{color:", "}"], OLAF, MARIGOLD);
const StyledUIIcon = styled(withTransientStyleProps(UIIcon)).withConfig({
  displayName: "GenerateButton__StyledUIIcon",
  componentId: "sc-10y9lmi-0"
})(["", ";"], props => props.$isLoading ? css(["animation:", " 1s infinite;"], pulseKeyframe) : "animation: ''");
const StyledUIButton = styled(withTransientStyleProps(UIButton)).withConfig({
  displayName: "GenerateButton__StyledUIButton",
  componentId: "sc-10y9lmi-1"
})(["", ""], props => props.$isLoading && `background-color: ${OBSIDIAN} !important; border-color: ${OBSIDIAN} !important;`);
const GenerateButton = ({
  disabled,
  disabledTooltipMessage,
  isLoading,
  hasCallSummary,
  onClick
}) => {
  const Message = isLoading && hasCallSummary ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "call-summary.loadingRegenerateBtn"
  }) : isLoading ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "call-summary.loadingGenerateBtn"
  }) : hasCallSummary ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "call-summary.regenerateBtn"
  }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "call-summary.generateBtn"
  });
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !disabled,
    title: disabledTooltipMessage,
    placement: "bottom",
    children: /*#__PURE__*/_jsxs(StyledUIButton, {
      "data-test-id": "call-summary--generate",
      "data-acceptance-test": "callSummaryGenerateBtn",
      use: "tertiary",
      onClick: onClick,
      disabled: disabled,
      size: "extra-small",
      $isLoading: isLoading,
      children: [/*#__PURE__*/_jsx(StyledUIIcon, {
        name: "artificialIntelligence",
        size: "xxs",
        $isLoading: isLoading
      }), Message]
    })
  });
};
export default GenerateButton;